module.exports = __webpack_public_path__ + "img/lower_won.31cd6460.svg";